import { render, staticRenderFns } from "./tanimla.vue?vue&type=template&id=0863e13d&scoped=true&"
import script from "./tanimla.vue?vue&type=script&lang=js&"
export * from "./tanimla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0863e13d",
  null
  
)

export default component.exports